import React from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import { X } from 'lucide-react';

export const KeyTakeawaysNodeView: React.FC<any> = ({ deleteNode }) => {
  return (
    <NodeViewWrapper className="key-takeaways-box" contentEditable={false}>
      <button
        type="button"
        className="key-takeaways-remove-btn"
        onClick={deleteNode}
        title="Remove Key Takeaways"
      >
        <X size={14} />
      </button>
      <NodeViewContent />
    </NodeViewWrapper>
  );
};
